import React from 'react';

import { Link } from '@eika/link';

import ConfirmationScreen from '../../components/ConfirmationScreen/ConfirmationScreen';
import { useConfig } from '../../defaultConfig';
import { useTranslation } from '../../translations';
import { kredittbankenTrackingIDs } from '../../utils/gtm/kredittbankenTrackingIds';

const ConsumerLoanConfirmationScreen: React.FC = () => {
    const translated = useTranslation();
    const {
        links: { applyForConsumerLoan },
    } = useConfig();

    return (
        <ConfirmationScreen
            title={translated.confirmationScreen.consumerLoanTitle}
            link={
                <Link
                    href={applyForConsumerLoan?.url}
                    linkType="button-positive"
                    data-track-id={kredittbankenTrackingIDs.applyForConsumerLoan}
                    data-track-linkname={translated.confirmationScreen.loanLinkText}
                >
                    {translated.confirmationScreen.loanLinkText}
                </Link>
            }
        />
    );
};

export default ConsumerLoanConfirmationScreen;
